import React from 'react';

import { AccessSettingsForm, AddEmployeeToTeam, AssignTaskToEmployee } from '@features';
import { TModal } from '@widgets/MyTeam/model/types';

export const MyTeamModals = ({
    currentModal,
    onCloseCurrentModal,
    onChangeCurrentClickedId,
    currentClickedId,
    onEmployeeAdded,
}: {
    currentModal: TModal;
    onCloseCurrentModal: () => void;
    onChangeCurrentClickedId: (id: number | null) => void;
    currentClickedId: number | null;
    onEmployeeAdded: () => void;
}) => (
    <>
        {currentModal === 'addEmployee' && (
            <AddEmployeeToTeam onCloseCb={onCloseCurrentModal} onSuccessCb={onEmployeeAdded} />
        )}
        {currentModal === 'accessSettings' && (
            <AccessSettingsForm
                onCloseCb={() => {
                    onCloseCurrentModal();
                    onChangeCurrentClickedId(null);
                }}
                currentClickedId={currentClickedId}
            />
        )}
        {currentModal === 'assignTaskToEmployee' && (
            <AssignTaskToEmployee
                onCloseCb={() => {
                    onCloseCurrentModal();
                    onChangeCurrentClickedId(null);
                }}
                currentClickedId={currentClickedId}
            />
        )}
    </>
);
